import { z } from "zod";
/** Response of `GET /health`. Liveness only: it never touches the database. */
export const healthResponseSchema = z.object({
    status: z.literal("ok"),
    uptimeSeconds: z.number().nonnegative(),
});
/** Response of `GET /ready`. Readiness includes the PostgreSQL check. */
export const readinessResponseSchema = z.object({
    status: z.enum(["ready", "not-ready"]),
    checks: z.object({
        database: z.enum(["ok", "unavailable"]),
    }),
});
//# sourceMappingURL=health.js.map